module.exports = __webpack_public_path__ + "static/media/transportPagePhone.43619a12.svg";